import React from "react";

// Progression dans le questionnaire : barre + texte lisible (« Question 3 sur 6 »),
// exposée comme progressbar aux technologies d'assistance.
const ProgressBar = ({ current, total }) => {
  const label = `Question ${current} sur ${total}`;
  const percent = total > 0 ? Math.round((current / total) * 100) : 0;
  return (
    <div className="progress_container mt-3">
      <div
        className="progress_track"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={current}
      >
        <div className="progress_bar" style={{ width: percent + "%" }} />
      </div>
      <div className="progress_text" aria-hidden="true">
        {label}
      </div>
    </div>
  );
};

export default ProgressBar;
